import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_7b5c189b from 'nuxt_plugin_plugin_7b5c189b' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_db0dda16 from 'nuxt_plugin_sentryserver_db0dda16' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2cbfa16d from 'nuxt_plugin_sentryclient_2cbfa16d' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_238c6933 from 'nuxt_plugin_plugin_238c6933' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_3d5b222a from 'nuxt_plugin_pluginutils_3d5b222a' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_091bccf5 from 'nuxt_plugin_pluginrouting_091bccf5' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_08d04a9a from 'nuxt_plugin_pluginmain_08d04a9a' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_vuewarehouse_4e893bab from 'nuxt_plugin_vuewarehouse_4e893bab' // Source: ./vue-warehouse.js (mode: 'all')
import nuxt_plugin_workbox_7c437de6 from 'nuxt_plugin_workbox_7c437de6' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_a63fa9c0 from 'nuxt_plugin_metaplugin_a63fa9c0' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_9cf05ed8 from 'nuxt_plugin_iconplugin_9cf05ed8' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_markdownit_4aea9ced from 'nuxt_plugin_markdownit_4aea9ced' // Source: ./markdownit.js (mode: 'all')
import nuxt_plugin_googleanalytics_08316b55 from 'nuxt_plugin_googleanalytics_08316b55' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_axios_48421431 from 'nuxt_plugin_axios_48421431' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginclient_54cbc2d2 from 'nuxt_plugin_pluginclient_54cbc2d2' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_3b53901f from 'nuxt_plugin_pluginserver_3b53901f' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_image_3349112c from 'nuxt_plugin_image_3349112c' // Source: ./image.js (mode: 'all')
import nuxt_plugin_pluginserver_14a42a6b from 'nuxt_plugin_pluginserver_14a42a6b' // Source: ./color-mode/plugin.server.js (mode: 'server')
import nuxt_plugin_pluginclient_a22a8e3a from 'nuxt_plugin_pluginclient_a22a8e3a' // Source: ./color-mode/plugin.client.js (mode: 'client')
import nuxt_plugin_theme_352fc904 from 'nuxt_plugin_theme_352fc904' // Source: ../../../plugins/theme.js (mode: 'client')
import nuxt_plugin_auth_60e5cadf from 'nuxt_plugin_auth_60e5cadf' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":(titleChunk) => {
      return titleChunk && titleChunk !== 'PocketPasta'
        ? `${titleChunk} | PocketPasta`
        : 'PocketPasta';
    },"noscript":[{"innerHTML":"This website requires JavaScript.","once":true,"hid":"noscript"}],"meta":[{"once":true,"name":"charset","hid":"charset","content":"utf-8"},{"property":"og:title","title":"PocketPasta","template":(titleChunk) => {
          return titleChunk && titleChunk !== 'PocketPasta'
            ? `${titleChunk} | PocketPasta`
            : 'PocketPasta';
        },"hid":"og:title"},{"hid":"google-site-verification","once":true,"name":"google-site-verification","content":"LqVnUnYGR8NrvXrhnFgW5RjNJVChZp2j2OEP55xjE30"},{"once":true,"name":"version","hid":"version","content":"0.49.1"},{"once":true,"http-equiv":"Accept-CH","hid":"Accept-CH","content":"DPR, Viewport-Width, Width"}],"link":[{"once":true,"rel":"icon","hid":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Fpocketpasta.com","hid":"preconnect-https:\u002F\u002Fpocketpasta.com","crossorigin":"anonymous","once":true},{"rel":"preconnect","href":"https:\u002F\u002Fres.cloudinary.com","hid":"preconnect-https:\u002F\u002Fres.cloudinary.com","crossorigin":"anonymous","once":true},{"rel":"preconnect","href":"https:\u002F\u002Fwww.google-analytics.com","hid":"preconnect-https:\u002F\u002Fwww.google-analytics.com","crossorigin":"anonymous","once":true},{"rel":"preconnect","href":"https:\u002F\u002Fwww.google.com","hid":"preconnect-https:\u002F\u002Fwww.google.com","crossorigin":"anonymous","once":true},{"rel":"preconnect","href":"https:\u002F\u002Fwww.googletagmanager.com","hid":"preconnect-https:\u002F\u002Fwww.googletagmanager.com","crossorigin":"anonymous","once":true},{"rel":"preconnect","href":"https:\u002F\u002Fstats.g.doubleclick.net","hid":"preconnect-https:\u002F\u002Fstats.g.doubleclick.net","crossorigin":"anonymous","once":true},{"rel":"preconnect","href":"https:\u002F\u002Fwww.googletagmanager.com","hid":"preconnect-https:\u002F\u002Fwww.googletagmanager.com","crossorigin":"anonymous","once":true}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7b5c189b === 'function') {
    await nuxt_plugin_plugin_7b5c189b(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_db0dda16 === 'function') {
    await nuxt_plugin_sentryserver_db0dda16(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2cbfa16d === 'function') {
    await nuxt_plugin_sentryclient_2cbfa16d(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_238c6933 === 'function') {
    await nuxt_plugin_plugin_238c6933(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_3d5b222a === 'function') {
    await nuxt_plugin_pluginutils_3d5b222a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_091bccf5 === 'function') {
    await nuxt_plugin_pluginrouting_091bccf5(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_08d04a9a === 'function') {
    await nuxt_plugin_pluginmain_08d04a9a(app.context, inject)
  }

  if (typeof nuxt_plugin_vuewarehouse_4e893bab === 'function') {
    await nuxt_plugin_vuewarehouse_4e893bab(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_7c437de6 === 'function') {
    await nuxt_plugin_workbox_7c437de6(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_a63fa9c0 === 'function') {
    await nuxt_plugin_metaplugin_a63fa9c0(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_9cf05ed8 === 'function') {
    await nuxt_plugin_iconplugin_9cf05ed8(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_4aea9ced === 'function') {
    await nuxt_plugin_markdownit_4aea9ced(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_08316b55 === 'function') {
    await nuxt_plugin_googleanalytics_08316b55(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_48421431 === 'function') {
    await nuxt_plugin_axios_48421431(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_54cbc2d2 === 'function') {
    await nuxt_plugin_pluginclient_54cbc2d2(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_3b53901f === 'function') {
    await nuxt_plugin_pluginserver_3b53901f(app.context, inject)
  }

  if (typeof nuxt_plugin_image_3349112c === 'function') {
    await nuxt_plugin_image_3349112c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_14a42a6b === 'function') {
    await nuxt_plugin_pluginserver_14a42a6b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_a22a8e3a === 'function') {
    await nuxt_plugin_pluginclient_a22a8e3a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_theme_352fc904 === 'function') {
    await nuxt_plugin_theme_352fc904(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_60e5cadf === 'function') {
    await nuxt_plugin_auth_60e5cadf(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
